import { createApiRef } from '@backstage/frontend-plugin-api';
import type {
  GroupSlackChannel,
  GroupSlackChannelInput,
  SlackChannelQuery,
  SlackChannelSearch,
} from './types';

export interface GroupSlackChannelsApi {
  listMappings(): Promise<GroupSlackChannel[]>;
  setMapping(mapping: GroupSlackChannelInput): Promise<void>;
  deleteMapping(groupRef: string): Promise<void>;
  listChannels(query?: SlackChannelQuery): Promise<SlackChannelSearch>;
}

export const groupSlackChannelsApiRef =
  createApiRef<GroupSlackChannelsApi>().with({
    id: 'group-slack-channels',
    pluginId: 'app',
  });
